// TODO: Instead of relying on javascript/typescript for date formatting implementing moment.js would be better here.
export class DateHelpers {
  public static getTodaysDate() {
    return this.convertToString(new Date())
  }

  public static convertToString(date: Date) {
    return date.toISOString().substr(0, 10)
  }

  public static convertToDate(isoString: string) {
    return new Date(isoString)
  }
}
